/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WinterhalterOperationStatus {
    Created = 1,
    Instructed = 2,
    Canceled = 3,
    Done = 4,
    Transition = 5,
}
